var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("progress-bar", {
    attrs: {
      progressColor: _vm
        .color(_vm.progressColor)
        .fade(0.7)
        .string(),
      thumbColor: _vm.thumbColor,
      highlightColor: _vm.highlightColor,
      duration: _vm.duration,
      time: _vm.playtime,
      ghost: _vm.ghost,
      buffer: _vm.buffer,
      chapters: _vm.chapters,
      quantiles: _vm.quantiles,
      title: _vm.$t(_vm.title.key, _vm.title.attr),
      "data-test": "progress-bar"
    },
    on: { input: _vm.dispatch, simulate: _vm.dispatch, ghost: _vm.dispatch }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }